import type { FaireProductEntity } from "../../entity_types/product";

export const p_9u97vnot0u: FaireProductEntity = {
  token: "p_9u97vnot0u",
  type: "product",
  name: "Everything Hurts and I'm Dying Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/efa14f8adf0ea0fe8ff4210d3ad0e5152975d5468aec740599a0f6ed33a87b36/1561151414.jpg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6436ddb7cafa30c249fbdebc7aaf1226ccc632eccc8f579f850469563aa8400.jpeg",
    "https://cdn.faire.com/fastly/3053b4565deff182f4a51c5c47a131655331c693c1dc89eaefa4bfa5d274a203.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/8f0b6f47fc91a109869fab253052db8f77c856227addad30f6ab1e650e47c3a9.jpeg",
    "https://cdn.faire.com/fastly/f32a503751f81fb8de117472e84b8484e90036934646b05c6e13f297013d9891.jpeg"
  ],
  priceDollars: 6.75,
  description: "After a long day of bullshit, kick your feet up and relax… These will not only cushion your tired tootsies, they'll even complain for you, too!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:08.688Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
